<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus"> </h1>

			<email-form
					:subject="subject"
					:body="email_body"
					on-success-url="/help?#/submitted"
					edit-body
					must-edit
					:payload="{order_id, order_line_id}"
					destination-key="ge"
			></email-form>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';
	import EmailForm from './../components/EmailForm';
	import Axios from 'axios';

	export default {
		name: "MeantOtherPaymentMethod",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				order_id: null,
				order_line_id: null,
			};
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						self.order_id = response.data['data']['order_id'];
						self.order_line_id = response.data['data']['order_line_id'];
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},

		computed: {
			email_body() {
				const voucher_name = (!this.$globs || !this.$globs.institute_info) ?  'voucher' : this.$globs.institute_info['voucher_name'].toLocaleLowerCase();
				return `I would like to swap my payment for my order to this ${voucher_name}: `;
			},
			subject() {
				return (!this.$globs || !this.$globs.institute_info) ?
					'I meant to pay with my Voucher / Financial Aid / School Charge Account' :
					this.$globs.institute_info['meant_other_payment_method'];
			}
		}
	}
</script>

<style scoped>

</style>
